/* eslint no-console:0 */

// needed for IE with axios
//import 'core-js/features/promise';
//import 'core-js/features/symbol/for';

import "babel-polyfill"

// Vue libraries:
import Vue from "vue";
import axios from "config/axios.js"
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
import VueMoment from "vue-moment";
Vue.use(VueMoment);

// Vuetify libraries:
import "vuetify/src/stylus/app.styl"
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify, {
  VApp,
  VAlert,
  VAutocomplete,
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VChip,
  VContent,
  VContainer,
  VDataTable,
  VDatePicker,
  VDialog,
  VDivider,
  VExpandTransition,
  VFlex,
  VForm,
  VFooter,
  VLayout,
  VList,
  VIcon,
  //VInput,
  VListTile,
  VListTileAction,
  VListTileContent,
  VListTileSubTitle,
  VListTileTitle,
  VMenu,
  //VOverflowBtn,
  VRadio,
  VRadioGroup,
  VSelect,
  VSpacer,
  VTextField,
  VToolbar,
  VTooltip,
  VToolbarSideIcon,
  VToolbarTitle,
  VNavigationDrawer
} from "vuetify/lib"

Vue.use(Vuetify, {
  components: {
    VApp,
    VAlert,
    VAutocomplete,
    VBtn,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VChip,
    VContent,
    VContainer,
    VDataTable,
    VDatePicker,
    VDialog,
    VDivider,
    VExpandTransition,
    VFlex,
    VForm,
    VFooter,
    VLayout,
    VList,
    VIcon,
    //VInput,
    VListTile,
    VListTileAction,
    VListTileContent,
    VListTileSubTitle,
    VListTileTitle,
    VMenu,
    //VOverflowBtn,
    VRadio,
    VRadioGroup,
    VSelect,
    VSpacer,
    VTextField,
    VToolbar,
    VTooltip,
    VToolbarSideIcon,
    VToolbarTitle,
    VNavigationDrawer
  },
  theme: {
    primary: "0B87D1"
  }
})

// Common styles (overwrites, colors, etc.)
import "packs/src/validator.scss"

// Icons
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCompass,
  faLaptopMedical,
  faUserInjured,
  faUserMd
/*
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCompass,
  faEdit,
  faExclamationCircle,
  faExclamationTriangle,
  faIndent,
  faPlus,
  faQuestionCircle,
  faSortAlphaDown,
  faTrash,
  faUserInjured,
  faUserMd
  */
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(
  faCompass,
  faLaptopMedical,
  faUserInjured,
  faUserMd
/*
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCompass,
  faEdit,
  faExclamationCircle,
  faExclamationTriangle,
  faIndent,
  faPlus,
  faQuestionCircle,
  faSortAlphaDown,
  faTrash,
  faUserInjured,
  faUserMd
  */
);
Vue.component("fa-icon", FontAwesomeIcon);

// TARMED Validator components:
import App from "components/validator/App";

document.addEventListener("DOMContentLoaded", function () {
  let element = document.getElementById("validator");
  if (element != null) {
    const validatorApp = new Vue({
      el: element,
      components: {
        App
      },
      axios
    });
  }
});
